import React from "react";
import classes from "./ContactItems.module.css";
import ContactItem from "./ContactItem/ContactItem";

const CONTACTS = [
  {
    action: "mailto:support@techytraders.com",
    icon: "fas fa-envelope fa-3x",
    style: { color: "#333" },
  },
  {
    action: "https://twitter.com/techytraders",
    icon: "fab fa-twitter fa-3x",
    style: { color: "#333" },
  },
  {
    action: "https://www.linkedin.com/company/techytraders",
    icon: "fab fa-linkedin fa-3x",
    style: { color: "#333" },
  },
];

const ContactItems = (props) => {
  return (
    <div className={classes.ContactItems}>
      {CONTACTS.map((item, index) => (
        <ContactItem
          key={index}
          style={item.style}
          action={item.action}
          icon={item.icon}
        />
      ))}
    </div>
  );
};

export default ContactItems;
